export default {
  companyKennitala: {
    is: 'Kennitala fyrirtækis',
    en: 'Company Id. No.',
  },
  continue: {
    is: 'Áfram',
    en: 'Continue',
  },

  name: { is: 'Nafn tengiliðs' },
  email: { is: 'Netfang tengiliðs' },
  phonenumber: { is: 'Símanúmer tengiliðs' },
};
